import { ReactNode, useEffect } from 'react';
import { OfflineBanner } from './OfflineBanner';
import { InstallPrompt } from './InstallPrompt';
import { useOfflineSync } from '@/hooks/useOfflineSync';

interface PWAProviderProps {
  children: ReactNode;
}

export function PWAProvider({ children }: PWAProviderProps) {
  // Initialize sync in background
  useOfflineSync();

  // Register service worker updates
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((registration) => {
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New content available, prompt user to refresh
                console.log('New content available, refresh to update.');
              }
            });
          }
        });
      });
    }
  }, []);

  return (
    <>
      <OfflineBanner />
      {children}
      <InstallPrompt />
    </>
  );
}
